import React from 'react';
import ClubDealsExperts from '../../sections/FormBoxSection/InfoBar/Experts/Experts';
import styles from './SuccessMessageWithExperts.module.scss';

const SuccessMessageWithExperts = ({ title, subtitle, experts }) => {
  return (
    <div className={ styles.SuccessMessageWithExperts }>
      <ClubDealsExperts experts={ experts } />
      <div className={ styles.headers }>
        <h2 className={ styles.title }>{ title }</h2>
        <h3 className={ styles.subtitle }>{ subtitle }</h3>
      </div>
    </div>
  );
};
 
export default SuccessMessageWithExperts;
